import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    id: 0,
    periodo: '1900-01-01',
    periodoDia: 1,
    periodoMes: 0,
    periodoMesNombre: null,
    periodoAnio: 0,
    observaciones: '',
    renglones: [],
    totalPresupuesto: 0,

    datos: [],
    renglonesDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_PRESUPUESTO'(state, presupuestoGastosId) {
        state.id = presupuestoGastosId || 0;
        let fecha = moment(new Date()).format('YYYY-MM-DD');
        state.periodo = fecha;
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.observaciones = '';
        state.rowVersion = null;
        
        state.renglones = [];
        state.totalPresupuesto = 0;
    },
    'SET_CONCEPTOS'(state, conceptos) {
        state.renglones = conceptos.map(concepto => ({
            id: helpers.methods.getUUID(),
            presupuestoGastosConceptoId: concepto.id,
            presupuestoGastosConcepto: concepto.nombre.trim(),
            importe: 0
        }));
    },
    'SET_PRESUPUESTO'(state, presupuestoGastos) {
        state.periodo = moment(presupuestoGastos.periodo).format('YYYY-MM-DD');
        state.periodoMes= new Date(presupuestoGastos.periodo).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(presupuestoGastos.periodo).getFullYear();
        state.observaciones = presupuestoGastos.observaciones.trim();
        state.rowVersion = presupuestoGastos.rowVersion;

        presupuestoGastos.renglones.forEach(renglon => {
            let concepto = state.renglones.find(t => t.presupuestoGastosConceptoId == renglon.presupuestoGastosConceptoId);
            
            if (concepto) {
                concepto.importe = parseFloat(renglon.importe);
            } else {
                state.renglones.push({
                    id: helpers.methods.getUUID(),
                    presupuestoGastosConceptoId: renglon.presupuestoGastosConceptoId,
                    presupuestoGastosConcepto: renglon.presupuestoGastosConcepto.nombre.trim(),
                    importe: renglon.importe
                })
            }
        });

        calcularTotales(state);
    },
    'SET_PRESUPUESTO_BASE'(state, presupuestoGastos) {
        presupuestoGastos.renglones.forEach(renglon => {
            let concepto = state.renglones.find(t => t.presupuestoGastosConceptoId == renglon.presupuestoGastosConceptoId);
            
            if (concepto) {
                concepto.importe = parseFloat(renglon.importe);
            } else {
                if (parseFloat(renglon.importe) != 0) {
                    state.renglones.push({
                        id: helpers.methods.getUUID(),
                        presupuestoGastosConceptoId: renglon.presupuestoGastosConceptoId,
                        presupuestoGastosConcepto: renglon.presupuestoGastosConcepto.nombre.trim(),
                        importe: renglon.importe
                    })
                }
            }
        });

        calcularTotales(state);
    },
    'CALCULAR_TOTALES'(state) {
        calcularTotales(state);
    },
    'SET_IMPORTE'(state, params) {
        let renglon = state.renglones.find(t => t.id == params.id);
        if (renglon) {
            renglon.importe = parseFloat(params.importe);
        }
        calcularTotales(state);
    },

    'INICIALIZAR_DATOS'(state) {
        state.datos = [];
        state.renglonesDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.datos = params.datos;
        state.renglonesDatos = params.renglones;
    },
};

function calcularTotales (state) {
    state.totalPresupuesto = state.renglones.reduce((total, renglon) => {
            return total + parseFloat(renglon.importe);
        }, 0);
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, presupuestoGastosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PRESUPUESTO', presupuestoGastosId);
            
            if (presupuestoGastosId != 0){
                apiAxios.get('presupuestos-gastos-conceptos/list')
                    .then(res => {
                        commit('SET_CONCEPTOS', res.data);

                        return apiAxios.get(`presupuestos-gastos/${presupuestoGastosId}/abm`);
                    })
                    .then(res => {
                        commit('SET_PRESUPUESTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                apiAxios.get('presupuestos-gastos-conceptos/list')
                    .then(res => {
                        commit('SET_CONCEPTOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
    duplicarPresupuesto( { commit }, presupuestoGastosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PRESUPUESTO');
            
            if (presupuestoGastosId != 0){
                apiAxios.get('presupuestos-gastos-conceptos/list')
                    .then(res => {
                        commit('SET_CONCEPTOS', res.data);

                        return apiAxios.get(`presupuestos-gastos/${presupuestoGastosId}/abm`);
                    })
                    .then(res => {
                        commit('SET_PRESUPUESTO_BASE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject('Se produjo un error al recuperar el código del presupuesto base');
            }
        })
    },
    actualizarImporte ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('SET_IMPORTE', params);
            resolve();
        })
    },
    save ( {} ) {
        return new Promise((resolve, reject) => {
            let periodo = parseInt(state.periodoAnio).toString().trim()
                + '-' + helpers.methods.getMesNumero(state.periodoMesNombre).toString().trim()
                + '-01';

            let presupuestoGastos= {
                periodo,
                observaciones: state.observaciones.trim(),
                renglones: state.renglones.map(renglon => ({
                    presupuestoGastosConceptoId: renglon.presupuestoGastosConceptoId,
                    importe: parseFloat(renglon.importe)
                }))
            }
            
            let url = 'presupuestos-gastos';
            if (state.id != 0) {
                url += '/' + state.id;
                presupuestoGastos.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, presupuestoGastos)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, presupuestoGastosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (presupuestoGastosId != 0) {
                apiAxios.get(`presupuestos-gastos/${presupuestoGastosId}`) 
                    .then(res => {
                        // let periodo = this.$options.filters.moneda(this.importe, this.moneda)

                        let datos = [
                            { 'nombre': 'periodo', 'campo': 'Periodo', 'valor': res.data.periodo, 'formato': 'periodo' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                        ];
                        let params = {
                            datos: datos,
                            renglones: res.data.renglones
                        }
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}